import type { MenuItem } from '../store/useStore'

/**
 * 写真が無い品の代わりに出す絵。
 *
 * **`src=""` を描かないために要る。** 空文字を渡すと React が警告を出すうえ、
 * ブラウザによってはページ自身を再取得しにいく。`onError` では拾えない — あれは
 * 「読みに行って失敗した」ときだけで、**空 src はそもそも読みに行かない**。
 *
 * 写真の無い商品は普通にある（seed 投入・一括登録・EC からの取り込み・
 * 店舗が写真を付けずに登録）ので、表示側で必ず受け止める。以前は保存時に
 * 箸のストック写真を既定で入れて誤魔化していたが、無関係な商品に箸の写真が
 * 付いて出るので**やめた** (#1890)。
 */
export const NO_IMAGE = 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><rect width="100" height="100" fill="%23f3f4f6"/><text x="50" y="58" font-size="30" text-anchor="middle">🍽️</text></svg>'

/**
 * その品の写真を並び順で返す。
 *
 * ギャラリー（#1890）が無ければメイン 1 枚に落とす — 旧データと、ギャラリーを
 * 持たない飲食メニューがこれ。**先頭は常にメイン写真**（サーバが
 * `imageUrl = imageUrls[0]` に揃える）。
 */
export function galleryOf(item: Pick<MenuItem, 'imageUrl' | 'imageUrls'>): string[] {
  const urls = (item.imageUrls || []).filter(Boolean)
  if (urls.length) return urls
  return item.imageUrl ? [item.imageUrl] : []
}
